import { useTrend } from '../api/hooks';
import { TrendChart } from '../charts/TrendChart';
import { EmptyState, ErrorState } from '../components/EmptyState';
import { Panel } from '../components/Panel';
import { isEmptySelection } from '../state/filters';
import { PageShell, usePage } from './PageShell';
import { t } from '../i18n';

export function Trends() {
  const { state, query } = usePage();
  const empty = state ? isEmptySelection(state) : false;
  const trend = useTrend(empty ? null : query);
  const yrs = state ? `${state.from}–${state.to}` : '';

  const note = (
    <>
      {state?.indicator && <span>{state.indicator}</span>}
      {yrs && <span> · {yrs}</span>}
      {t.trendNote && <span className="text-dim"> · {t.trendNote}</span>}
    </>
  );

  return (
    <PageShell title={t.trendsTitle} note={note}>
      <Panel>
        {trend.isError ? (
          <ErrorState error={trend.error} />
        ) : trend.isPending && !empty ? (
          <div className="skeleton" style={{ height: 420 }} />
        ) : !trend.data?.rows.length || empty ? (
          <EmptyState />
        ) : (
          <TrendChart data={trend.data} />
        )}
      </Panel>
    </PageShell>
  );
}
